<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-grid">
        <!-- 联系方式 -->
        <div class="footer-column">
          <h3 class="footer-title">联系方式</h3>
          <div class="footer-contact">
            <p class="contact-info" v-if="settings.company_address">
              <i class="el-icon-location"></i>
              <span>{{ settings.company_address }}</span>
            </p>
            <p class="contact-info" v-if="settings.contact_phone">
              <i class="el-icon-phone"></i>
              <span>{{ settings.contact_phone }}</span>
            </p>
            <p class="contact-info" v-if="settings.contact_email">
              <i class="el-icon-message"></i>
              <span>{{ settings.contact_email }}</span>
            </p>
          </div>
        </div>
        
        <!-- 关注我们 -->
        <div class="footer-column">
          <h3 class="footer-title">关注我们</h3>
          <div class="footer-qrcode-wrapper">
            <div class="qrcode-item" v-if="settings.wechat_qrcode">
              <img :src="settings.wechat_qrcode" alt="微信公众号" class="qrcode-img" />
              <p class="qrcode-label">微信公众号</p>
            </div>
            <div class="qrcode-item" v-if="settings.douyin_qrcode">
              <img :src="settings.douyin_qrcode" alt="抖音号" class="qrcode-img" />
              <p class="qrcode-label">抖音号</p>
            </div>
          </div>
        </div>
        
        <!-- 友情链接 -->
        <div class="footer-column">
          <h3 class="footer-title">友情链接</h3>
          <div class="footer-links">
            <a href="http://www.china-safety.org.cn" target="_blank" rel="noopener noreferrer" class="footer-link">中国安全生产协会</a>
            <a href="http://www.samr.gov.cn" target="_blank" rel="noopener noreferrer" class="footer-link">国家市场监管总局</a>
            <a href="http://www.csei.org.cn" target="_blank" rel="noopener noreferrer" class="footer-link">中国特种设备检测研究院</a>
          </div>
        </div>
      </div>
      
      <!-- 版权信息 -->
      <div class="footer-copyright">
        <p v-if="settings.copyright_text">{{ settings.copyright_text }}</p>
        <p v-if="settings.icp_number"><a :href="`https://beian.miit.gov.cn`" target="_blank" rel="noopener noreferrer" style="color: rgba(255, 255, 255, 0.6); text-decoration: none;">{{ settings.icp_number }}</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
import settingsMixin from '@/mixins/settingsMixin'

export default {
  name: 'Footer',
  mixins: [settingsMixin],
  mounted() {
    this.fetchSettings()
  }
}
</script>

<style scoped>
/* Footer 样式 */
.footer {
  background: linear-gradient(90deg, #1e3a8a 0%, #93c5fd 100%);
  color: #ffffff;
  min-height: 270px;
  padding: 50px 0 0;
  display: flex;
  align-items: center;
}

.footer-container {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 60px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-column {
  display: flex;
  flex-direction: column;
}

.footer-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 24px 0;
  color: #ffffff;
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contact-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0;
  font-size: 14px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.8);
}

.contact-info i {
  font-size: 16px;
  color: #1890ff;
  margin-top: 2px;
}

.footer-qrcode-wrapper {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.qrcode-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.qrcode-img {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  background: #ffffff;
  padding: 4px;
  transition: transform 0.3s, box-shadow 0.3s;
}

.qrcode-item:hover .qrcode-img {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.qrcode-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  margin: 0;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #1890ff;
}

.footer-copyright {
  padding: 20px 0;
  text-align: center;
}

.footer-copyright p {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

/* 响应式设计 */
@media (max-width: 992px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  }
}

@media (max-width: 768px) {
  .footer {
    min-height: auto;
    padding: 40px 0 0;
  }
  
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  
  .footer-qrcode-wrapper {
    gap: 16px;
  }
  
  .qrcode-img {
    width: 80px;
    height: 80px;
  }
  
  .qrcode-label {
    font-size: 12px;
  }
}
</style> 